import { IgChip, IgDot } from "@intelligems/ig-theme";
import { Stack, useTheme } from "@mui/material";

export interface WorkspaceStatusChipsProps {
  /** Lifecycle chip text, or `null` for domains/scopes with no lifecycle. */
  statusLabel: string | null;
  /** Active published version number, or `null` when nothing is live. */
  activeVersion: number | null;
}

/**
 * Lifecycle state and the version currently serving.
 *
 * Extracted alongside {@link WorkspaceActions} so an embedded workspace can
 * answer "is this live, and on what version?" in its own header rather than
 * losing the answer with the suppressed title bar.
 */
export const WorkspaceStatusChips = ({
  statusLabel,
  activeVersion,
}: WorkspaceStatusChipsProps) => {
  const theme = useTheme();

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {statusLabel !== null && (
        <IgChip
          size="small"
          icon={
            <IgDot
              color={theme.palette.success.main}
              size={6}
              sx={{ ml: "8px !important" }}
            />
          }
          color={"success"}
          label={statusLabel}
        />
      )}
      <IgChip
        color={"primary"}
        size="small"
        icon={
          <IgDot
            color={theme.palette.primary.main}
            size={6}
            sx={{ ml: "8px !important" }}
          />
        }
        label={
          activeVersion !== null
            ? `v${activeVersion} active`
            : "No active version"
        }
      />
    </Stack>
  );
};
